import table from "../../General CSS/Table.module.css";
import getClaims, {ClaimTemplate, deleteClaim, submitClaim} from "../../API/ClaimManager";
import React, {useEffect, useState} from "react";
import Header from "../../Header";
import {getMe} from "../../Auth/Tokens";
import {useNavigate} from "react-router-dom";
import {Housemate} from "../../Types/Housemate";

export default function ViewClaims() {
    const [claims, setClaims] = useState<ClaimTemplate[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        getClaims()
            .then(setClaims)
            .catch(err => setError(err.message || "Unknown error"))
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <Header page={"Claims"} returnLink={"/account/overview"}/>
            {claims ? (
                <LoadClaims initialClaims={claims} />
            ) : (
                <p>Loading Claims...</p>
            )}
        </>
    )
}

function LoadClaims({initialClaims}: {initialClaims: ClaimTemplate[]}) {
    const [me, setMe] = useState<Housemate | null>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMe = async () => {
            try {
                const me = await getMe();
                setMe(me);
            } catch (error: any) {
                setError(error.message || "Unknown error");
                setMe(null);
            } finally {
                setLoading(false);
            }
        }

        fetchMe();
    }, [])

    const [claims, setClaims] = useState<ClaimTemplate[]>(initialClaims);

    useEffect(() => {
        setClaims(initialClaims);
    }, [initialClaims]);

    const handleDelete = async (id: number) => {
        try {
            await deleteClaim(id);
            setClaims(prevClaims => prevClaims.filter(claim => claim.id !== id));
        } catch (error: any) {
            setError(error.message || "Unknown error");
        }
    };

    const [deleteHoveredId, setDeleteHoveredId] = useState<number | null>(null);
    const [submitHoveredId, setSubmitHoveredId] = useState<number | null>(null);

    const handleSubmit = (claimUid: number) => {
        if (!window.confirm("Are you sure you want to submit this claim?")) {
            return;
        }

        submitClaim(claimUid)
            .then(() => {
                setClaims(claims.filter(claim => claim.id !== claimUid));
                window.alert("Claim submitted successfully!");
            })
            .catch(error => setError(error));
    }

    return (
        <div className={table.table}>
            <table>
                <thead>
                <tr>
                    <th>Amount</th>
                    <th>Requested By</th>
                    <th>Reason</th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {claims.map((claim: ClaimTemplate) => (
                    <tr key={claim.id}>
                        <td>£{claim.amount}</td>
                        <td>{claim.requestedBy.name}</td>
                        <td>{claim.reason}</td>
                        {(me?.accessLevel === "FULL" && (claim.requestedBy.payeeUid !== undefined && claim.requestedBy.payeeUid !== "")) ? (
                            <td>
                                <span onClick={() => {handleSubmit(claim.id)}}
                                      style={{
                                          color: submitHoveredId === claim.id ? "lightgreen" : "green",
                                          fontWeight: "bold",
                                          cursor: "pointer",
                                          transition: "0.2s background-color ease-in-out",
                                          textAlign: "center"
                                }}
                                      onMouseEnter={() => setSubmitHoveredId(claim.id)}
                                      onMouseLeave={() => setSubmitHoveredId(null)}
                                >Submit</span>
                            </td>) : (<td>
                            </td>)}
                        {(me?.accessLevel === "FULL" || claim.requestedBy.email === me?.email) && <td
                            style={{
                                cursor: "pointer",
                                fontWeight: "bold",
                                color: deleteHoveredId === claim.id ? "darkred" : "red",
                                transition: "0.2s background-color ease-in-out",
                                textAlign: "center"
                            }}
                            onClick={() => handleDelete(claim.id)}
                            onMouseEnter={() => setDeleteHoveredId(claim.id)}
                            onMouseLeave={() => setDeleteHoveredId(null)}
                        >
                            Delete
                        </td>
                        }
                    </tr>
                ))}
                </tbody>
            </table>
            <CreateClaim />
        </div>
    );
}

function CreateClaim() {
    const navigate = useNavigate();

    return (
        <button onClick={() => {navigate("/account/create-claim")}}>
            Create Claim
        </button>
    )
}